export enum FreshServiceStatusEnum {
    Na = 1,
    Open,
    Pending,
    Resolved,
    Closed,
}